import type { KottiField } from '../kotti-field/types'

export const KOTTI_FIELD_INLINE_EDIT_SUPPORTS: KottiField.Supports = {
	autoComplete: true,
	borderless: false,
	clear: false,
	decoration: false,
	placeholder: true,
	tabIndex: true,
}
